import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatCount } from "./dashboardKit";

// Icon chips only - the number and label stay in ink so a tile never depends on
// its colour to be read.
const TONES = {
  brand:   "bg-brand-50 text-brand-600",
  violet:  "bg-violet-50 text-violet-600",
  indigo:  "bg-indigo-50 text-indigo-600",
  cyan:    "bg-cyan-50 text-cyan-600",
  emerald: "bg-emerald-50 text-emerald-600",
  amber:   "bg-amber-50 text-amber-600",
  rose:    "bg-rose-50 text-rose-600",
  slate:   "bg-gray-100 text-gray-600",
};

// Compact metric tile for the top row of a dashboard.
const StatTile = ({ icon: Icon, label, value, hint, tone = "brand", to, loading }) => {
  const chip = TONES[tone] ?? TONES.brand;
  const formatted = formatCount(value);

  const inner = (
    <>
      <div className="flex items-start justify-between">
        <span className={`grid h-9 w-9 place-items-center rounded-xl ${chip}`}>
          <Icon size={17} strokeWidth={1.9} />
        </span>
        {to && (
          <ArrowUpRight
            size={15}
            className="text-gray-300 transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-brand-500"
          />
        )}
      </div>

      <div className="mt-4">
        {/* A tile with no value is a plain link to a module, so it skips the number. */}
        {value === undefined && !loading ? null : loading ? (
          <div className="h-7 w-12 animate-pulse rounded-md bg-gray-100" />
        ) : (
          <p className="text-[26px] font-semibold leading-none tracking-tight text-gray-900">
            {formatted ?? <span className="text-gray-300">0</span>}
          </p>
        )}
        <p className="mt-1.5 text-[13px] font-medium text-gray-500">{label}</p>
        {hint && <p className="mt-0.5 text-[11px] text-gray-400">{hint}</p>}
      </div>
    </>
  );

  const shell =
    "group flex flex-col rounded-2xl border border-gray-200/80 bg-white p-4 shadow-card transition duration-200";

  return to ? (
    <Link to={to} className={`${shell} hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-pop`}>
      {inner}
    </Link>
  ) : (
    <div className={shell}>{inner}</div>
  );
};

export default StatTile;
